var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9266 2.45305V9.98639C11.9266 11.3064 10.8532 12.3797 9.53324 12.3797C8.21991 12.3797 7.13991 11.3064 7.13991 9.98639C7.13991 8.67305 8.21991 7.59972 9.53324 7.59972C10.0932 7.59972 10.5932 7.79305 10.9999 8.11305V4.14639L4.85991 5.89305V11.2731C4.85991 12.5931 3.77991 13.6664 2.46658 13.6664C1.14658 13.6664 0.0732422 12.5931 0.0732422 11.2731C0.0732422 9.95972 1.14658 8.88639 2.46658 8.88639C3.01991 8.88639 3.51991 9.07972 3.92658 9.39305V3.49972C3.92658 2.51972 4.51991 1.75972 5.45991 1.50639L9.31324 0.453054C10.0932 0.239721 10.7532 0.313054 11.2199 0.673054C11.6932 1.02639 11.9266 1.62639 11.9266 2.45305Z",
    fill: "#0057FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicIcon);
export default __webpack_public_path__ + "static/media/music-icon.aaacbdf56a149fb0815f890bd79495f8.svg";
export { ForwardRef as ReactComponent };